export default __webpack_public_path__ + "static/media/users.7aa9798f.svg";